<template>
    <div class="vrm-filter_options__tags">
        <div v-if="label" class="vrm-filter_options__tags__header">
            <p>
                {{
                    i18n
                        ? $t(i18n, {
                              i18nFallback: label,
                          })
                        : label
                }}
            </p>
            <label class="vrm-filter_options__check">
                <span>
                    {{
                        $t('tags.select_all', {
                            i18nFallback: 'Select all',
                        })
                    }}
                </span>
                <input ref="selectAll" type="checkbox" @change="onChangeSelectAll" />
                <div class="sg-alternative-display">
                    <div class="sg-icon-check" />
                </div>
            </label>
        </div>
        <div class="vrm-tags__tag-list">
            <label v-for="option in options" :key="option.id" class="vrm-tags__tag">
                <input :id="option.id" v-model="option.value" type="checkbox" @change="onChange" />
                <span class="vrm-tags__tag__button">{{ option.label }}</span>
            </label>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('installationoverview')
@AngularLocaleBundle('tags')
@AngularLocaleBundle('dashboard')
@AngularLocaleBundle('core')
export default class VrmInstallationOverviewFilterTags extends Vue {
    @Prop({ type: Array, default: [] })
    options;
    @Prop({ type: String, default: '', required: false })
    label;
    @Prop({ type: String, default: undefined, required: false })
    i18n;

    // To make sure the select all checkbox is updated when the options
    // change by selecting them or clicking clear all from parent component
    @Watch('options', { deep: true })
    onOptionsChange() {
        this.setSelectAllState();
    }

    mounted() {
        this.setSelectAllState();
    }

    setSelectAllState() {
        const selectAllCheckbox = this.$refs.selectAll;
        if (!selectAllCheckbox) return;

        const allOptionsSelected = this.options.every(option => option.value);
        const noOptionsSelected = this.options.every(option => !option.value);
        selectAllCheckbox.indeterminate = !allOptionsSelected && !noOptionsSelected;
        selectAllCheckbox.checked = allOptionsSelected;
    }

    onChange() {
        this.$emit('submit', null);
    }

    onChangeSelectAll() {
        this.options.forEach(option => {
            option.value = this.$refs.selectAll.checked;
        });
        this.$emit('submit', null);
    }
}
</script>
